import React from "react";

function Audio() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="30px"
      height="30px"
      viewBox="0 0 345 345"
    >
      <g>
        <path
          fill="#fff"
          d="M172.539,0.003C77.405,0.003,0,77.405,0,172.544c0,95.141,77.405,172.542,172.539,172.542
		c95.137,0,172.551-77.401,172.551-172.542C345.084,77.405,267.676,0.003,172.539,0.003z M151.973,209.493
		c0,6.323-2.879,12.105-7.449,14.952c-4.566,2.876-10.064,2.348-14.201-1.388l-31.243-28.019c-1.414,0.648-2.996,1.045-4.668,1.045
		H68.254c-6.167,0-11.166-5.008-11.166-11.175v-26.166c0-6.173,4.999-11.16,11.166-11.16h26.157c2.072,0,3.996,0.604,5.65,1.58
		l30.261-27.16c2.372-2.12,5.188-3.2,8.022-3.2c2.104,0,4.23,0.606,6.179,1.819c4.57,2.882,7.449,8.656,7.449,14.964V209.493z
		 M186.503,206.802c-2.456,0-4.918-0.942-6.791-2.816c-3.753-3.759-3.753-9.848,0-13.595c4.768-4.768,7.397-11.103,7.397-17.858
		c0-6.737-2.63-13.081-7.397-17.852c-3.753-3.753-3.753-9.839,0-13.589c3.753-3.759,9.842-3.759,13.595,0
		c8.395,8.398,13.03,19.57,13.03,31.441c0,11.89-4.636,23.059-13.03,31.453C191.421,205.86,188.971,206.802,186.503,206.802z
		 M215.356,227.092c-2.456,0-4.924-0.937-6.792-2.81c-3.753-3.76-3.753-9.842,0-13.596c21.035-21.028,21.017-55.25-0.012-76.281
		c-3.753-3.75-3.753-9.839,0-13.589s9.842-3.756,13.595,0c28.529,28.531,28.529,74.942,0.006,103.466
		C220.28,226.156,217.818,227.092,215.356,227.092z M251.007,250.74c-1.88,1.873-4.342,2.81-6.792,2.81
		c-2.462,0-4.93-0.937-6.797-2.81c-3.759-3.76-3.759-9.836,0-13.596c17.252-17.258,26.745-40.189,26.745-64.6
		c0-24.403-9.5-47.351-26.77-64.602c-3.753-3.75-3.753-9.839,0-13.589c3.759-3.759,9.842-3.759,13.595,0
		c20.897,20.888,32.402,48.654,32.402,78.191C283.385,202.094,271.886,229.861,251.007,250.74z"
        />
      </g>
    </svg>
  );
}

export default Audio;
